"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readDataFromFile = readDataFromFile;
exports.getFileExtensionForMimeType = getFileExtensionForMimeType;
const sonar_ts_types_1 = require("@sonar-software/sonar-ts-types");
/**
 * Parses the provided file and provides the resulting data string or buffer.
 * @param file Target {@link File} to read.
 * @returns String or {@link ArrayBuffer} data of the file.
 */
function readDataFromFile(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result));
        reader.readAsDataURL(file);
    });
}
const mimeTypeExtensionMap = {
    [sonar_ts_types_1.MimeType.JPEG]: sonar_ts_types_1.FileExtension.JPEG,
    [sonar_ts_types_1.MimeType.PNG]: sonar_ts_types_1.FileExtension.PNG
};
/**
 * Gets the appropriate file extension for the provided mime type.
 * @param mimeType {@link MimeType} to get the extension for.
 * @returns The {@link FileExtension} related to the provided {@link MimeType}.
 */
function getFileExtensionForMimeType(mimeType) {
    return mimeTypeExtensionMap[mimeType];
}
//# sourceMappingURL=lib.js.map